module.exports = __webpack_public_path__ + "img/works-detail_3.3c2528d4.png";